import React, { memo, useMemo } from 'react';
import { PLATFORM_ICON_MAP } from '../Icons/V3';
import * as styles from './SmallLinksBar.module.scss';
import SmallLinkButton from './SmallLinkButton';
import { PLATFORM_COLOR_MAP } from '../../constants';

const SmallLinksBar = ({
  smallLinks,
  creatorName,
  disableDeeplinks = false,
}) => {
  const smallLinkButtons = useMemo(
    () =>
      smallLinks.map(({ platform, link }) => {
        const Icon = PLATFORM_ICON_MAP[platform];
        if (!Icon) {
          return null;
        }

        return (
          <SmallLinkButton
            key={platform}
            url={link}
            platform={platform}
            creatorName={creatorName}
            disableDeeplinks={disableDeeplinks}
            backgroundColor={PLATFORM_COLOR_MAP[platform]}
          >
            {Icon()}
          </SmallLinkButton>
        );
      }),
    [creatorName, disableDeeplinks, smallLinks]
  );

  if (!smallLinks?.length) {
    return null;
  }

  return <div className={styles.container}>{smallLinkButtons}</div>;
};

export default memo(SmallLinksBar);
